import {Injectable} from '@angular/core';
import {Application} from '../domain/onBoarding/application';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {EDocType} from '../enums/EDocType';
import {ERequestType} from '../enums/ERequestType';
import {TranslateService} from '@ngx-translate/core';
import {ApplicationBody} from '../domain/onBoarding/application-body';
import {ApplicationEntity} from '../entity/ApplicationEntity';

@Injectable()
export class ApplicationService {
  // FIXME mover el estado de la app de aquí, verificar que no sea destruido, si hay errores de posible pérdida del estado, es por esto
  application: Application = new ApplicationEntity();

  constructor(
    private http: HttpClient,
    private baseService: BaseService,
    private translate: TranslateService,
  ) {
  }

  clearApplication() {
    this.application = new ApplicationEntity();
  }

  setApplication(submit = false, ocrNeeded = false, validateSelfieIdentity = false) {
    this.application.body.locale = this.translate.currentLang;
    const formData = new FormData();
    // TODO verificar por que no enviar los docs cuando es recovery
    // if (!recovery && this.application.submitted) {
    if (this.application.identificationFront && this.application.sendIdentificationFront) {
      if (this.application.uploadedId1Front) {
        formData.append('identificationFront', this.application.identificationFront);
      } else {
        formData.append(
          'identificationFront', this.formatBase64ToFile(this.application.identificationFront, EDocType.IDENTIFICATION_FRONT));
      }
    }
    if (this.application.identification2Front && this.application.sendIdentification2Front) {
      if (this.application.uploadedId2Front) {
        formData.append('identification2Front', this.application.identification2Front);
      } else {
        formData.append(
          'identification2Front', this.formatBase64ToFile(this.application.identification2Front, EDocType.IDENTIFICATION2_FRONT));
      }
    }
    if (this.application.identificationBack && this.application.sendIdentificationBack) {
      if (this.application.uploadedId1Back) {
        formData.append('identificationBack', this.application.identificationBack);
      } else {
        formData.append('identificationBack', this.formatBase64ToFile(this.application.identificationBack, EDocType.IDENTIFICATION_BACK));
      }
    }
    if (this.application.identification2Back && this.application.sendIdentification2Back) {
      if (this.application.uploadedId2Back) {
        formData.append('identification2Back', this.application.identification2Back);
      } else {
        formData.append(
          'identification2Back', this.formatBase64ToFile(this.application.identification2Back, EDocType.IDENTIFICATION2_BACK));
      }
    }
    if (this.application.selfie && this.application.sendSelfie) {
      if (this.application.uploadedSelfie) {
        formData.append('selfie', this.application.selfie);
      } else {
        formData.append(
          'selfie', this.formatBase64ToFile(this.application.selfie, EDocType.SELFIE));
      }
    }
    formData.append('submitted', JSON.stringify(submit));
    formData.append('body', JSON.stringify(this.application.body));
    return this.http.post(`/onboarding/applications?ocr=${ocrNeeded}&validateSelfieIdentity=${validateSelfieIdentity}`, formData);
  }

  submitKyc(applicationId, data) {
    if (this.application.cipQ) {
      return this.http.post(`/onboarding/applications/${applicationId}/kyc`, {questions: data});
    } else {
      return this.http.post(`/onboarding/applications/${applicationId}/kyc`, {});
    }
  }

  sendOtp(data, type) {
    return this.http.post(`/onboarding/authorizations/${type}/validate-availability`, data);
  }

  validateOtp(data, type) {
    return this.http.post(`/onboarding/authorizations/otp/${type}-validate`, data);
  }

  recoverApplication(token) {
    return this.http.get(`/onboarding/applications?applicationToken=${token}`);
  }

  getDocument(id, docType) {
    return this.http.get(`/onboarding/applications/${id}/documents?docType=${docType}`, {responseType: 'arraybuffer'});
  }

  sendDocument(email: string, doc: string) {
    return this.http.post(`/onboarding/applications/contracts/${doc}/send`, {
      email
    });
  }

  cancelRequest(token: string, type: ERequestType) {
    return this.http.put(`/onboarding/user/cancel/${token}?type=${type}`, null);
  }

  // TODO esto no se ve bien, hay que revisarlo, parece que hace un encodign a patín
  formatBase64ToFile(img, fileName): File {
    const arr = img.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, {type: mime});
  }

  onboardingInitialConfiguration() {
    return this.http.get(`/onboarding/applications/configuration/`);
  }

  saveCurp(application: ApplicationBody) {
    return this.http.post(`/onboarding/applications/${application.applicationId}/curp`, {});
  }
  getCodeValidation(code: string){
    return this.http.get(`/onboarding/applications/validate-altair-agent-code/${code}`);
  }

  getApplicationReponse(hash: string){
    return this.http.get(`/onboarding/applications/response/${hash}`);
  }
}
